import React, { FC } from 'react'

import { ArtistForm, ProductList } from 'modules/Artists/components'
import { useServiceUpdateArtist } from 'modules/Artists/serviceHooks'

import { ArtistFormContainerProps } from './ArtistFormContainer.props'

import './ArtistFormContainer.scss'

const ArtistFormContainer: FC<ArtistFormContainerProps> = ({
  products,
  artist
}) => {
  const { zoneOptions, gpsUnitsOptions, onSubmitArtist, methods, opusIdValue } = useServiceUpdateArtist(artist)

  return (
    <form onSubmit={methods.handleSubmit(onSubmitArtist)} className="artist-form" id="artist-form">
      <h4 className="artist-form__title">Artist Information</h4>
      <ArtistForm
        labelsOptions={zoneOptions}
        gpsUnitsOptions={gpsUnitsOptions}
        hasOpusIdValue={!!opusIdValue}
        control={methods.control}
      />
      {
        products.length ? (
          <>
            <h4 className="artist-form__title">Products</h4>
            <ProductList products={products} projects={artist.campaigns || []} labelsOptions={zoneOptions} />
          </>
        ) : null
      }
    </form>
  )
}

export default ArtistFormContainer
